import { render, staticRenderFns } from "./ClassInfo.vue?vue&type=template&id=6e660505&scoped=true&"
import script from "./ClassInfo.vue?vue&type=script&lang=js&"
export * from "./ClassInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e660505",
  null
  
)

export default component.exports